import {Component, computed, input, InputSignal, signal} from "@angular/core";
import {MatIcon} from "@angular/material/icon";
import {objectTypeToMatSymbol} from "../../../shared/material-icons";
import {thumbnailFallbackIcon} from "../../../shared/thumbnail-fallback-icon";
import {SearchObject} from "../../../core/definitions/search-object";

@Component({
  selector: 'app-search-result-thumbnail-image',
  imports: [
    MatIcon,
  ],
  templateUrl: './search-result-thumbnail-image.html',
  styleUrl: './search-result-thumbnail-image.scss',
  host: {
    'class': 'search-result-thumbnail-image'
  }
})
export class SearchResultThumbnailImage {
  item: InputSignal<SearchObject> = input();

  imageLoadError = signal(false);

  imageUrl = computed<string | null>(() => this.item().$$imageUrl || null);
  iconName = computed(() =>
    this.imageLoadError()
      ? thumbnailFallbackIcon(this.item().object_type)
      : objectTypeToMatSymbol(this.item().object_type));

  onImageError() {
    this.imageLoadError.set(true);
  }
}
